<template>
  <TemplateRegistro :titulo="titulo" :texto="texto" @intro="submit()">
    <label for="uname"><strong>Nº de documento de identidad</strong></label>
    <input
      id="uname"
      v-model.trim="nif"
      type="text"
      placeholder="Escribe aquí tu NIF/CIF/NIE"
      required
      @keydown="clearErrors()"
    />

    <PanelMensajes :mensaje="error" clase="error" />

    <label class="aceptacion">
      <input v-model="acepto" type="checkbox" @change="clearErrors()" /> He
      leído y acepto el
      <a href="https://www.mmtseguros.com/aviso-legal" target="_blank"
        >Aviso Legal</a
      >
      y la
      <a href="https://www.mmtseguros.com/politica-privacidad" target="_blank"
        >Política de Privacidad</a
      >.
    </label>

    <button class="pure-button ripple" @click.prevent="submit()">
      <strong>Continuar</strong>
    </button>
  </TemplateRegistro>
</template>

<script>
export default {
  props: {
    titulo: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      nif: this.$route.params.nif,
      error: "",
      texto:
        "Escribe el Nº de Documento de Identidad asociado a tus pólizas en MMT Seguros.",
      acepto: false
    };
  },

  methods: {
    submit: async function() {
      if (this.nif == "") {
        this.error = "Escribe tu NIF/CIF/NIE";
        return;
      }

      if (!this.acepto) {
        this.error = "Debes aceptar las condiciones del servicio";
        return;
      }

      let result = await this.$store.dispatch("verificaUsuario", this.nif.replace(/\s/g, ''));
      console.log(result);
      if (result.codigo != 0) {
        console.log("hay error");
        this.error = result.mensaje;
        return;
      }
      this.$router.replace({ name: "registroTelefono" });
    },

    clearErrors() {
      this.error = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.aceptacion {
  font-size: 0.85rem;
}
</style>
